/* Header notification bell (snippets/header-bell.liquid). Moved out of the inline header markup so the
   20 KB script is cached and no longer sits in front of the page's first image. */
(function () {
  'use strict';

  // Settings come from the JSON block rendered by snippets/header-bell.liquid
  var configEl = document.querySelector('script[data-hb-config]');
  if (!configEl) return;
  var C;
  try { C = JSON.parse(configEl.textContent || '{}'); } catch (e) { return; }

  var ID       = C.id;
  var SEEN_KEY = 'hb_seen_' + ID;   // eski sürüm: tüm kampanya listesinin tek parmak izi
  var SEEN2    = 'hb_seen_v2';      // görülen kart anahtarları
  var FP       = C.fp;
  var TITLE    = C.title;
  var BRAND    = C.brand;
  var MONEY    = C.money;
  var ROOT     = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  var CFG  = C.cfg;
  var CART = C.cart;

  var $ = function (id) { return document.getElementById(id); };

  var btn       = $('hb-btn-'        + ID);
  var overlay   = $('hb-overlay-'    + ID);
  var panel     = $('hb-panel-'      + ID);
  var close     = $('hb-close-'      + ID);
  var list      = $('hb-list-'       + ID);
  var mine      = $('hb-mine-'       + ID);
  var mineList  = $('hb-mine-list-'  + ID);
  var camp      = $('hb-camp-'       + ID);
  var campTitle = $('hb-camp-title-' + ID);
  var empty     = $('hb-empty-'      + ID);
  /* Sepete ekleme header'ı yeniden çizer; zil düğümleri değişebileceği için her seferinde yeniden bulunur */
  var badgeEl = function () { return $('hb-badge-' + ID); };
  var wrapEl  = function () { return $('hb-wrap-'  + ID); };
  var glowEl  = function () { return $('hb-glow-'  + ID); };

  if (!btn || !panel || !list) return;

  /* ── Flash önleme ────────────────────────── */
  function readyPanel () {
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        panel && panel.classList.add('hb-panel--ready');
      });
    });
  }
  function hardClose () {
    if (!panel) return;
    panel.style.transition   = 'none';
    if (overlay) overlay.style.transition = 'none';
    panel.classList.remove('hb-panel--open', 'hb-panel--ready');
    if (overlay) overlay.classList.remove('hb-overlay--open');
    panel.setAttribute('aria-hidden', 'true');
    btn.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    stopAnim();
    open = false;
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        if (panel)   panel.style.transition   = '';
        if (overlay) overlay.style.transition = '';
        readyPanel();
      });
    });
  }
  window.addEventListener('pageshow', function (e) { if (e.persisted) hardClose(); });
  window.addEventListener('popstate', hardClose);

  /* ── Okunmamış takibi ────────────────────────
     Her kart bir data-hb-key taşır. Panel açılınca görünen anahtarlar kaydedilir;
     rozet yalnızca görülmemiş kartları sayar ve hepsi görülünce kaybolur. */
  function cardKeys () {
    return Array.prototype.map.call(list.querySelectorAll('[data-hb-key]'), function (el) {
      return el.getAttribute('data-hb-key');
    });
  }
  function readSeen () {
    try {
      var raw = localStorage.getItem(SEEN2);
      if (raw === null) {
        // Eski sürümde bu kampanya listesi görüldüyse kartları da görülmüş say
        return (FP && localStorage.getItem(SEEN_KEY) === FP) ? cardKeys() : [];
      }
      var arr = JSON.parse(raw);
      return Array.isArray(arr) ? arr : [];
    } catch (_) { return []; }
  }
  var seen = readSeen();

  function unseenCount () {
    return cardKeys().filter(function (k) { return seen.indexOf(k) === -1; }).length;
  }
  function paintBadge () {
    var n = unseenCount();
    var badge = badgeEl();
    if (badge) {
      // Only write on change: the header observer below would otherwise re-trigger itself
      var text = CFG.showCnt ? String(n) : '';
      if (badge.textContent !== text) badge.textContent = text;
      if (badge.hidden !== (n === 0)) badge.hidden = n === 0;
    }
    var b = $('hb-btn-' + ID);
    var label = n ? TITLE + ', ' + n + ' yeni bildirim' : TITLE;
    if (b && b.getAttribute('aria-label') !== label) b.setAttribute('aria-label', label);
    var glow = glowEl();
    if (glow) glow.classList.toggle('hb-glow--on', n > 0);
    if (n > 0 && !open) startAnim(); else stopAnim();
  }
  /* "Yeni" noktaları ve grup başlıkları; panel açıkken noktalar yerinde kalsın diye ayrı */
  function paintList () {
    list.querySelectorAll('[data-hb-key]').forEach(function (el) {
      el.classList.toggle('hb-item--new', seen.indexOf(el.getAttribute('data-hb-key')) === -1);
    });
    var hasMine = !!(mineList && mineList.querySelector('.hb-item'));
    var hasCamp = !!(camp && camp.querySelector('.hb-item'));
    if (mine) mine.hidden = !hasMine;
    if (campTitle) campTitle.hidden = !(hasMine && hasCamp);
    if (empty) empty.hidden = hasMine || hasCamp;
  }
  function paint () {
    paintList();
    paintBadge();
  }
  function markSeen () {
    cardKeys().forEach(function (k) { if (seen.indexOf(k) === -1) seen.push(k); });
    seen = seen.slice(-150);
    try { localStorage.setItem(SEEN2, JSON.stringify(seen)); } catch (_) {}
    paintBadge();
  }

  /* ── Animasyon ────────────────────────────── */
  var timer    = null;
  var cleanTmr = null;
  var animating = false;

  function ring () {
    var wrap = wrapEl();
    if (!wrap || document.hidden) return;
    var glow = glowEl();
    if (CFG.ring) {
      wrap.classList.remove('hb-wrap--ringing');
      void wrap.offsetWidth;
      wrap.classList.add('hb-wrap--ringing');
    }
    if (CFG.glow && glow && glow.classList.contains('hb-glow--on')) {
      wrap.classList.remove('hb-wrap--glowing');
      void wrap.offsetWidth;
      wrap.classList.add('hb-wrap--glowing');
    }
    clearTimeout(cleanTmr);
    cleanTmr = setTimeout(function () {
      var w = wrapEl();
      w && w.classList.remove('hb-wrap--ringing', 'hb-wrap--glowing');
    }, 1100);
  }
  function startAnim () {
    if (animating) return;
    animating = true;
    // With both effects switched off ring() has nothing to do, so don't wake up every few seconds
    if (!CFG.ring && !CFG.glow) return;
    ring();
    if (CFG.ringAuto && !timer) timer = setInterval(ring, CFG.ringMs);
  }
  function stopAnim () {
    animating = false;
    if (timer) { clearInterval(timer); timer = null; }
    var wrap = wrapEl();
    wrap && wrap.classList.remove('hb-wrap--ringing', 'hb-wrap--glowing');
  }

  /* ── Sana Özel kartları ───────────────────── */
  var ICONS = {
    bag:  '<path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/>',
    tag:  '<path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"/><line x1="7" y1="7" x2="7.01" y2="7"/>',
    heart:'<path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>'
  };
  var ARROW = '<span class="hb-item-arrow" aria-hidden="true"><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><polyline points="9,18 15,12 9,6"/></svg></span>';

  /* Same output as the money_without_trailing_zeros filter (",00" dropped) */
  function money (cents) {
    var placeholder = (MONEY.match(/\{\{\s*(\w+)\s*\}\}/) || [])[1] || 'amount';
    var comma = /comma_separator/.test(placeholder);
    var noDec = /no_decimals/.test(placeholder);
    var parts = (cents / 100).toFixed(noDec ? 0 : 2).split('.');
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, comma ? '.' : ',');
    var amount = parts[1] && Number(parts[1]) !== 0 ? whole + (comma ? ',' : '.') + parts[1] : whole;
    return MONEY.indexOf('{' + '{') > -1 ? MONEY.replace(/\{\{\s*\w+\s*\}\}/, amount) : amount + ' ' + MONEY;
  }

  /* o: { key, href?, icon? | img?, label?, title, desc?: (string|Node)[], progress?: 0..1 } */
  function makeItem (o) {
    var el = document.createElement(o.href ? 'a' : 'div');
    el.className = 'hb-item' + (open ? ' hb-item--in' : '');
    if (o.href) el.href = o.href;
    el.setAttribute('data-hb-key', o.key);

    var media;
    if (o.img) {
      media = document.createElement('img');
      media.className = 'hb-item-thumb';
      media.src = o.img;
      media.alt = '';
      media.width = 42;
      media.height = 42;
      media.loading = 'lazy';
    } else {
      media = document.createElement('div');
      media.className = 'hb-item-icon';
      media.style.background = BRAND;
      media.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + ICONS[o.icon || 'bag'] + '</svg>';
    }

    var body = document.createElement('div');
    body.className = 'hb-item-body';
    if (o.label) {
      var label = document.createElement('span');
      label.className = 'hb-item-label';
      label.textContent = o.label;
      body.appendChild(label);
    }
    var title = document.createElement('p');
    title.className = 'hb-item-title';
    title.textContent = o.title;
    body.appendChild(title);
    if (o.desc) {
      var desc = document.createElement('p');
      desc.className = 'hb-item-desc';
      o.desc.forEach(function (part) { desc.append(part); });
      body.appendChild(desc);
    }
    if (typeof o.progress === 'number') {
      var bar = document.createElement('div');
      bar.className = 'hb-progress';
      bar.setAttribute('aria-hidden', 'true');
      bar.innerHTML = '<span></span>';
      bar.style.setProperty('--hb-progress', Math.round(Math.min(1, o.progress) * 100) + '%');
      body.appendChild(bar);
    }

    el.append(media, body);
    if (o.href) el.insertAdjacentHTML('beforeend', ARROW);
    return el;
  }
  function tag (name, text) {
    var n = document.createElement(name);
    n.textContent = text;
    return n;
  }

  /* Sepet: otomatik "X ve üzeri ürüne indirim" hedefine ilerleme, hedefe ulaşınca hatırlatma */
  function renderCart (cart) {
    var old = $('hb-cart-' + ID);
    if (old) old.remove();
    if (cart && cart.item_count > 0 && mineList) {
      var n = cart.item_count;
      var token = String(cart.token || '').split('?')[0];
      var item;
      if (CART.min > 0 && n < CART.min) {
        var left = CART.min - n;
        item = makeItem({
          key: 'cart:' + token + ':need',
          href: CART.url,
          icon: 'tag',
          label: 'Sepetin',
          title: left + ' ürün daha ekle, ' + CART.reward + ' kazan',
          desc: ['Sepetinde ' + n + ' ürün var. İndirim kod gerekmeden sepette uygulanır.'],
          progress: n / CART.min
        });
      } else {
        var saved = Number(cart.total_discount) || 0;
        item = makeItem({
          key: 'cart:' + token + ':ok',
          href: ROOT + 'cart',
          icon: 'bag',
          label: 'Sepetin',
          title: 'Sepetinde ' + n + ' ürün seni bekliyor',
          desc: saved > 0
            ? [tag('strong', money(saved)), ' indirim sepetine uygulandı']
            : ['Siparişini tamamlamayı unutma']
        });
      }
      item.id = 'hb-cart-' + ID;
      mineList.insertBefore(item, mineList.firstChild);
    }
    paint();
  }

  var cartCtl = null;
  var cartTmr = null;
  function loadCart () {
    clearTimeout(cartTmr);
    cartTmr = setTimeout(function () {
      if (cartCtl) cartCtl.abort();
      cartCtl = new AbortController();
      fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' }, signal: cartCtl.signal })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (cart) { if (cart) renderCart(cart); })
        .catch(function () {});
    }, 150);
  }

  /* Favoriler: eklendiği andaki fiyattan ucuzlayan ürünler (assets/wishlist.js fiyatı kuruş olarak saklar) */
  var FAV_CACHE = 'hb_fav_cache';
  var FAV_TTL   = 30 * 60 * 1000;
  var favRun    = 0;

  function readFavs () {
    var key = window.__swistCustomerId ? 'wl_' + window.__swistCustomerId : 'wl_guest';
    try {
      var arr = JSON.parse(localStorage.getItem(key) || '[]');
      if (!Array.isArray(arr)) return [];
      return arr
        .filter(function (f) { return f && f.handle && Number(f.price) > 0; })
        .sort(function (a, b) { return (b.addedAt || 0) - (a.addedAt || 0); })
        .slice(0, 12);
    } catch (_) { return []; }
  }
  function readCache () {
    try { return JSON.parse(sessionStorage.getItem(FAV_CACHE) || '{}') || {}; } catch (_) { return {}; }
  }
  function fetchProduct (handle, cache) {
    var hit = cache[handle];
    if (hit && Date.now() - hit.t < FAV_TTL) return Promise.resolve(hit.p);
    return fetch(ROOT + 'products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        var p = j ? { title: j.title, url: j.url, price: j.price, available: j.available, img: j.featured_image || '' } : null;
        cache[handle] = { t: Date.now(), p: p };
        return p;
      })
      .catch(function () { return null; });
  }
  function thumb (src) {
    if (!src) return '';
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=96';
  }
  function loadFavDrops () {
    var run = ++favRun;
    var favs = readFavs();
    var cache = readCache();
    Promise.all(favs.map(function (f) {
      return fetchProduct(f.handle, cache).then(function (p) { return p ? { fav: f, p: p } : null; });
    })).then(function (rows) {
      try { sessionStorage.setItem(FAV_CACHE, JSON.stringify(cache)); } catch (_) {}
      if (run !== favRun || !mineList) return;   // daha yeni bir çalışma başladı
      mineList.querySelectorAll('[data-hb-fav]').forEach(function (el) { el.remove(); });

      var drops = rows.filter(function (r) { return r && r.p.available && r.p.price < Number(r.fav.price); });
      drops.slice(0, 2).forEach(function (r) {
        var item = makeItem({
          key: 'drop:' + r.fav.id + ':' + r.p.price,
          href: r.p.url,
          img: thumb(r.p.img),
          label: 'Favorinde fiyat düştü',
          title: r.p.title,
          desc: [tag('s', money(Number(r.fav.price))), ' → ', tag('strong', money(r.p.price))]
        });
        item.setAttribute('data-hb-fav', '');
        mineList.appendChild(item);
      });
      if (drops.length > 2) {
        var more = makeItem({
          key: 'drop-more:' + drops.slice(2).map(function (r) { return r.fav.id + ':' + r.p.price; }).join(','),
          href: ROOT + 'pages/favorilerim',
          icon: 'heart',
          label: 'Favorilerin',
          title: (drops.length - 2) + ' favori ürününde daha fiyat düştü',
          desc: ['Favorilerime git']
        });
        more.setAttribute('data-hb-fav', '');
        mineList.appendChild(more);
      }
      paint();
    });
  }

  /* ── Panel animasyonu ─────────────────────── */
  function animItems () {
    if (!list) return;
    var items = list.querySelectorAll('.hb-item');
    // .hb-item starts at opacity 0 in CSS; an inline opacity beat the reduced-motion rule and hid the items
    items.forEach(function (el) { el.classList.remove('hb-item--in'); el.style.opacity = ''; });
    items.forEach(function (el, i) {
      setTimeout(function () { el.classList.add('hb-item--in'); }, 55 + i * 60);
    });
  }

  /* ── Aç / Kapat ───────────────────────────── */
  var open = false;
  var locked = false;

  function openPanel () {
    if (open) return;
    open = true;
    if (overlay) overlay.classList.add('hb-overlay--open');
    panel.classList.add('hb-panel--open');
    panel.setAttribute('aria-hidden', 'false');
    btn.setAttribute('aria-expanded', 'true');
    if (window.innerWidth < 750) {
      document.body.style.overflow = 'hidden';
      locked = true;
    }
    animItems();
    setTimeout(markSeen, 700);
    // Move keyboard / screen-reader focus into the dialog
    setTimeout(function () { if (open && close) close.focus({ preventScroll: true }); }, 60);
  }

  function closePanel (returnFocus) {
    if (!open) return;
    open = false;
    if (overlay) overlay.classList.remove('hb-overlay--open');
    panel.classList.remove('hb-panel--open');
    panel.setAttribute('aria-hidden', 'true');
    btn.setAttribute('aria-expanded', 'false');
    paint();   // görülen kartların "yeni" noktası kalkar
    // Unlock whatever the width is now: a rotation between open and close left the page frozen
    if (locked) {
      document.body.style.overflow = '';
      locked = false;
    }
    if (returnFocus !== false && (panel.contains(document.activeElement) || document.activeElement === document.body)) {
      btn.focus({ preventScroll: true });
    }
  }

  /* Keep Tab inside the open panel */
  panel.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab' || !open) return;
    var focusable = panel.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])');
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  /* Desktop has no overlay: close on a click outside the panel */
  document.addEventListener('click', function (e) {
    if (!open || !(e.target instanceof Node)) return;
    if (panel.contains(e.target) || btn.contains(e.target)) return;
    closePanel(false);
  });

  window.matchMedia('(max-width: 749px)').addEventListener('change', function () {
    if (open) closePanel(false);
  });

  btn.addEventListener('click', function (e) {
    e.preventDefault(); e.stopPropagation();
    open ? closePanel() : openPanel();
  });
  if (overlay) overlay.addEventListener('click', closePanel);
  if (close)   close.addEventListener('click', closePanel);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && open) closePanel();
  });

  /* Swipe ile kapat (mobil) */
  var sy = 0;
  panel.addEventListener('touchstart', function (e) { sy = e.touches[0].clientY; }, { passive: true });
  panel.addEventListener('touchend',   function (e) {
    if (e.changedTouches[0].clientY - sy > 55) closePanel();
  }, { passive: true });

  /* Başlat */
  readyPanel();
  document.body.appendChild(overlay);
  document.body.appendChild(panel);
  if (CFG.mine) {
    // İlk durum Liquid'den; sepet doluyken Liquid token vermezse kart anahtarı için cart.js'ten alınır
    if (CART.initial.item_count > 0 && !CART.initial.token) { paint(); loadCart(); }
    else renderCart(CART.initial);
    document.addEventListener('cart:update', loadCart);
    document.addEventListener('wishlist:change', loadFavDrops);
    var idle = window.requestIdleCallback || function (fn) { return setTimeout(fn, 1200); };
    idle(loadFavDrops, { timeout: 4000 });
  } else {
    paint();
  }

  /* Add to cart re-renders the header, which brings back fresh (dead) copies of the panel and
     overlay with the same IDs; drop them, the live ones are already in <body>. The fresh bell
     comes back with its server-side (hidden) badge, so the badge is repainted too. */
  var headerGroup = document.getElementById('header-group');
  if (headerGroup) {
    var repaint = 0;
    new MutationObserver(function () {
      headerGroup.querySelectorAll('#hb-panel-' + ID + ', #hb-overlay-' + ID).forEach(function (copy) {
        if (copy !== panel && copy !== overlay) copy.remove();
      });
      cancelAnimationFrame(repaint);
      repaint = requestAnimationFrame(paintBadge);
    }).observe(headerGroup, { childList: true, subtree: true });
  }
})();
